"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const colourStyles = {
  control: base => ({
    ...base,
    borderRadius: 0,
    textAlign: 'left'
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#050139',
    fontSize: 14,
    textAlign: 'left',
    backgroundColor: state.isSelected ? '#05A9B1' : provided.backgroundColor,
    color: state.isSelected ? 'white' : '#050139',
    ':active': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    },
    ':hover': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    borderColor: '#050139'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 100ms';
    return {
      ...provided,
      opacity,
      transition
    };
  },
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 0.75;
    const fontSize = '14px';
    const zIndex = 9999;
    return {
      ...provided,
      opacity,
      fontSize,
      zIndex
    };
  },
  dropdownIndicator: base => ({
    ...base,
    color: '#050139'
  }),
  placeholder: provided => ({
    ...provided,
    color: '#5A6770',
    fontSize: 12,
    textAlign: 'left'
  }),
  input: provided => ({
    ...provided,
    color: '#050139',
    fontSize: 12,
    textAlign: 'left'
  })
};
const Selector = props => {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({}, props, {
    styles: colourStyles
  }));
};
var _default = exports.default = Selector;